const MARKDOWN_MARKER_REGEX = /(\*\*|__|`)/g
const LEADING_BULLET_REGEX = /^\s*-\s+/
const NUMBERING_VARIANT_REGEX = /(^|\s)(\d+)[):]\s+/g
const INLINE_NUMBERED_ITEM_REGEX = /([^\n])\s+(\d+\.\s)/g

export function formatAssistantText(raw: string | null | undefined): string[] {
  if (!raw || !raw.trim()) {
    return []
  }

  let normalized = raw
    .replace(/\r\n?/g, '\n')
    .replace(MARKDOWN_MARKER_REGEX, '')

  normalized = normalized
    .split('\n')
    .map(line => line.replace(LEADING_BULLET_REGEX, '').trim())
    .join('\n')

  normalized = normalized
    .replace(NUMBERING_VARIANT_REGEX, '$1$2. ')
    .replace(INLINE_NUMBERED_ITEM_REGEX, '$1\n$2')
    .replace(/\n{3,}/g, '\n\n')
    .trim()

  return normalized
    .split('\n')
    .map(line => line.trim())
    .filter(Boolean)
}
